import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment'
import { ArticlePostSingleMagezine, InfoMagazine, MagezineDetail } from '../../shared/interfaces/index.interface';
import { JwtService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class SingleMagezineService {
  readonly BASE_URL = environment.BASE_API_URL;
  categoryName = new Subject<any>();
  categoryData = new BehaviorSubject<any>([]);
  magazineSubject = new BehaviorSubject(<MagezineDetail>{})
  magazinePermissions = new BehaviorSubject({})
  constructor(
    private http:HttpClient,
    public jwtService:JwtService
  ){}
  getSingleMagezine(name:string){
    return this.http.get<MagezineDetail>(`${this.BASE_URL}magazine/${name}/`)
  }
  getSingleMagezineInfo(name:string){
    return this.http.get<InfoMagazine>(`${this.BASE_URL}magazine/${name}/detail/`)
  }
  getSingleMagezinePost(name:string,page:number = 1){
    return this.http.get<ArticlePostSingleMagezine>(`${this.BASE_URL}post/?magazine__username=${name}&page=${page}&ordering=-publish_date`)
  }
  getSingleMagezineSearchedPost(name:string,title:string){
    if(title!='' && title!=null && title!=undefined){
      return this.http.get<ArticlePostSingleMagezine>(`${this.BASE_URL}post/?magazine__username=${name}&title__icontains=${title}&ordering=-publish_date`)
    }else{
      return this.http.get<ArticlePostSingleMagezine>(`${this.BASE_URL}post/?magazine__username=${name}&ordering=-publish_date`)
    }
  }
  getCategory(name:string | undefined){
    return this.http.get<any>(`${this.BASE_URL}magazine/${name}/post_category/?ordering=-priority`)
  }
  createCategory(data:any,magUsername:string){
    return this.http.post(this.BASE_URL+`magazine/${magUsername}/post_category/`, data)
  }
  updateCategory(data:any,id:any,magUsername:any){
    return this.http.patch(this.BASE_URL+`magazine/${magUsername}/post_category/${id}/`, data)
  }
  deleteCategory(data:any,magUsername:string){
    return this.http.delete(this.BASE_URL+`magazine/${magUsername}/post_category/${data.id}/`)
  }
  getCategorizedPost(magName:string,catID:number,page:number=1,headersObj:any){
    return this.http.get<ArticlePostSingleMagezine>(`${this.BASE_URL}post/?magazine__username=${magName}&page=${page}&category__in=${catID}&ordering=-publish_date`);
  }
  editMagazine(data:any, magazineUsername:string){
    return this.http.patch<any>(this.BASE_URL+`magazine/${magazineUsername}/`, data);
  }
  editMagazineAbout(username:string, data:any){
    return this.http.patch(this.BASE_URL+`magazine/${username}/profile/update/`, data)
  }
  editPriority(username:string,data:any){
    return this.http.put(this.BASE_URL+`magazine/${username}/post_category/priority/update/`, data)
  }
  getMagazineAbout(username:string){
    return this.http.get(this.BASE_URL+`magazine/${username}/profile/`)
  }
  createSupporter(username:string, data:any){
    return this.http.post(this.BASE_URL+`magazine/${username}/supporter/`,data)
  }
  updateSupporter(username:string, data:any, id:number){
    return this.http.patch(this.BASE_URL+`magazine/${username}/supporter/${id}/`, data)
  }
  deleteSupporter(username:string, id:number){
    return this.http.delete(this.BASE_URL+`magazine/${username}/supporter/${id}/`)
  }
  getSupporter(username:string){
    return this.http.get(this.BASE_URL+`magazine/${username}/supporter/`)
  }
  getMagazinePermission(username:string){
    return this.http.get(this.BASE_URL+`magazine/${username}/permissions/me/`)
  }
  newPost(username:string,data:any){
    return this.http.post(this.BASE_URL+`magazine_post/${username}/`, data)
  }
}